import { ARTIST_STATUS_CONSTANTS } from 'app-constants';
import { Status } from 'shared/enums';
import styled from 'styled-components';

interface StatusLabelProps {
  value: Status;
  className?: string;
}

const Label = styled.span`
  border-radius: 6px;
  padding: 5px 8px;
  font-weight: 600;
  display: block;
  width: 80px;
  line-height: 25px;
  text-align: center;
`;

export const StatusLabel = ({ value, className }: StatusLabelProps) => {
  return value in ARTIST_STATUS_CONSTANTS ? (
    <Label
      className={className}
      style={ARTIST_STATUS_CONSTANTS[value as keyof typeof ARTIST_STATUS_CONSTANTS]?.style}
    >
      {ARTIST_STATUS_CONSTANTS[value as keyof typeof ARTIST_STATUS_CONSTANTS]?.label}
    </Label>
  ) : (
    <div></div>
  );
};
